// Module
var code = "<img class=\"img-flag inline-block\" ng-src=\"assets/images/flags/{{vm.countryCode}}.svg\" width=\"6%\"/> ";
// Exports
module.exports = code;